package org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.pages.components.dialog.dialog.ErrorMsgDialog
import org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.components.dialogs.ClosingDailyReportDialog
import org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.components.dialogs.FinancialGroupDialog
import org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.mvi.ClosingReportsEvent
import org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.mvi.ClosingReportsState
import org.hs_soft.runmynesto.pages.home.sub_page.product.mvi.ProductEvent

@Composable
fun ClosingReportsDialog(
    windowSizeMode: WindowSizeModeEnum,
    state:ClosingReportsState,
    event:(ClosingReportsEvent)->Unit,
){
    if (state.showFinancialGroupDialog )
    {
        FinancialGroupDialog(
            modifier = Modifier,
            loading=state.financialGroupDialogLoading,
            selectedType = state.selectedFinancialGroup,
            submitFilterItems = {
                event(ClosingReportsEvent.SubmitFinancialGroup(it))
            },
            onCloseFilterClick = {
                event(ClosingReportsEvent.SetFinancialGroupStatus(false))
            }
        )
    }

    if (state.showClosingDailyReportDialog){
        ClosingDailyReportDialog(
            loading=state.dailyClosingDialogLoading,
            onCloseClick = {
                event(ClosingReportsEvent.SetClosingDailyReportDialogStatus(false))
            },
            submitClosingDailyReport = {
                event(ClosingReportsEvent.CloseDailyReport(reason = it))
            }

        )


    }

    if (state.errorInfo!=null){
        ErrorMsgDialog(
            windowSizeMode=windowSizeMode,
            description =state.errorInfo,
            onDismissDialog = {
                event(ClosingReportsEvent.DismissErrorDialog)
            }
        )
    }


}